<template>
    <el-form
        ref="product-info-form"
        :model="productData"
        :rules="rules"
        label-position="top"
        class="product-form__product-info"
    >
        <product-form-input-row>
            <template slot="inputs">
                <el-form-item prop="code">
                    <el-input
                        :value="code"
                        placeholder="Item Code"
                        @input="$emit('update:code', $event)"
                    >
                        <template slot="prepend"
                            >Code</template
                        >
                    </el-input>
                </el-form-item>
            </template>
            <template slot="description">
                Item Code is the code the most of the suppliers use to identify
                the product during ordering process.
            </template>
        </product-form-input-row>

        <product-form-input-row>
            <template slot="inputs">
                <el-form-item prop="name">
                    <el-input
                        :value="name"
                        placeholder="Item Name"
                        @input="$emit('update:name', $event)"
                    >
                        <template slot="prepend"
                            >Name</template
                        >
                    </el-input>
                </el-form-item>
            </template>
            <template slot="description">
                Item Name is the description of the product without branding and
                quantities, the cleaner is the description here, the easier the
                ordering process will be for you.
            </template>
        </product-form-input-row>

        <product-form-input-row>
            <template slot="inputs">
                <el-input
                    :value="brand"
                    placeholder="Item Brand"
                    @input="$emit('update:brand', $event)"
                >
                    <template slot="prepend"
                        >Brand</template
                    >
                </el-input>
            </template>
            <template slot="description">
                Item Brand is really important if you need to group/filter
                products by brands across the entire supplier offer.
            </template>
        </product-form-input-row>

        <product-form-input-row
            v-if="!currentSupplierId || currentSupplierId === '-'"
        >
            <template slot="inputs">
                <el-form-item prop="supplierId">
                    <supplier-search
                        :readonly="!!productData._id"
                        :selected-supplier="supplier"
                        @selected:supplier="supplierSelected"
                    >
                    </supplier-search>
                </el-form-item>
            </template>
        </product-form-input-row>

        <!--        <div class="product-form__order-method-selector">-->
        <!--            <h2>How do you order the product?</h2>-->
        <!--            <product-form-input-row>-->
        <!--                <template slot="inputs">-->
        <!--                    <el-radio-group-->
        <!--                            :value="type"-->
        <!--                            @input="$emit('update:type', $event)"-->
        <!--                    >-->
        <!--                        <el-radio-button label="UNIT"></el-radio-button>-->
        <!--                        <el-radio-button label="CARTON"></el-radio-button>-->
        <!--                        <el-radio-button label="QUANTITY"></el-radio-button>-->
        <!--                    </el-radio-group>-->
        <!--                </template>-->
        <!--            </product-form-input-row>-->
        <!--        </div>-->
    </el-form>
</template>

<script>
import FormIsValidMixin from "Mixins/FormIsValidMixin";
import SupplierSearch from "Components/SupplierSearch";

import ProductFormInputRow from "./ProductFormInputRow";

export default {
    components: {
        SupplierSearch,
        ProductFormInputRow,
    },
    mixins: [FormIsValidMixin],
    props: {
        currentSupplierId: String,
        productData: Object,
        code: String,
        name: String,
        brand: String,
        type: String,
        isEditingExistingProduct: Boolean,
    },
    data: () => ({
        rules: {
            code: [
                {
                    required: true,
                    message: "Please input an item code",
                    trigger: "blur",
                },
            ],
            name: [
                {
                    required: true,
                    message: "Please input an item name",
                    trigger: "blur",
                },
            ],
            // supplierId: [
            // {required: true, message: 'Please specify a supplier', trigger: 'blur'},
            // ],
        },
    }),

    computed: {
        supplier() {
            return {
                name: this.productData.supplierName,
                id: this.productData.supplierId,
            };
        },
    },

    mounted() {
        if (this.currentSupplierId) {
            this.productData.supplierId = this.currentSupplierId;
        }
    },

    methods: {
        supplierSelected(supplier) {
            this.productData.supplier = supplier;
            this.productData.supplierId = supplier._id;
            this.productData.supplierName = supplier.name;
        },

        handleClickNext() {
            this.$refs["product-info-form"].validate(isValid => {
                if (isValid) {
                    this.$emit("next");
                }
            });
        },

        handleClickSave() {
            console.log("saving...");

            this.$refs["product-info-form"].validate(isValid => {
                if (isValid) {
                    this.$emit("save");
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.product-form__product-info {
    display: flex;
    flex-direction: column;
    flex: 1;
}
</style>
